module.exports = __webpack_public_path__ + "img/icons8-form-100.c51b22bc.png";